// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"265":"Index","450":"CheckoutAlrajhi","456":"Success","757":"AwaitingPayment","910":"CheckoutAamaly","932":"Cancelled","980":"Failed"}[chunkId] || chunkId) + "." + {"265":"5e6d438e","450":"63f330dc","456":"b7567f71","648":"6b41ba4b","757":"25dba3bc","910":"3a503f93","932":"7fe99d4e","980":"b5afd919"}[chunkId] + ".js";
};